import DeliveryTerms from "./DeliveryTerms";
import DeliveryTermsForm from "./DeliveryTermsForm";

const DeliveryTermsConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/deliveryTerms',
            element: <DeliveryTerms />,
        },
        {
            path: '/addDeliveryTerms',
            element: <DeliveryTermsForm />,
        },
        {
            path: '/editDeliveryTerms/:id',
            element: <DeliveryTermsForm />,
        },
    ],
}

export default DeliveryTermsConfig;